import * as S from './TextLabel.styles'

interface TextLabelProps {
  children: React.ReactNode
  width?: string
  height?: string
  backgroundColor?: string
}

const TextLabel: React.FC<TextLabelProps> = ({
  children, width, height, backgroundColor,
}) => (
  <S.Container
    width={width}
    height={height}
    backgroundColor={backgroundColor}
  >
    { children }
  </S.Container>
)

export default TextLabel
